import { ComparisonAnswers } from './comparison-answers';
import { AdditionalView } from './additional-view';
import { InsuranceViewModel } from './insurance-view.model';
import { UserInfoViewModel } from '../optional-benefits/benefit-view.model';

export class ComparisonViewModel {
  insurances: InsuranceViewModel[];
  additions: AdditionalView[];
  compareIdentifier: string;
  model: any;

  constructor(values: any) {
    values.insurances = values.insurances.map(x => new InsuranceViewModel(x));
    values.additions = values.additions.map(x => new AdditionalView(x));
    Object.assign(this, values);
  }
}

export class PaymentResponseModel {
  success: boolean;
  insuranceAnswers: ComparisonAnswers;
  constructor(values) {
    Object.assign(this, values);
  }
}

export class RequestPageModel {
  facPageUrl: string;
  constructor(values: any) {
    Object.assign(this, values);
  }
}

export class PurchaseViewModel {
  premium: number;
  tax: number;
  subtotal: number;
  total: number;
  userInfo: UserInfoViewModel;
  invoiceNumber: string;
  compareIdentifier: string;

  constructor(values?: any) {
    Object.assign(this, values);
    this.userInfo = values ? new UserInfoViewModel(values.userInfo) : new UserInfoViewModel();
  }
}
export class RenewPurchaseViewModel extends PurchaseViewModel {
  isCurrentInsurer: boolean;
}

export class RenewPaymentResponseModel {
  success: boolean;
  companyId: number;
  compareIdentifier: string;
  invoiceNumber: string;

  constructor(values) {
    Object.assign(this, values);
  }
}
